import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { trackEvent } from './tracking';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';
import { useOrganization } from 'Shared/utils/hooks/use-organization';
import { useApp } from 'Shared/utils/hooks/use-app';

export const useWorkspaceSnapshotTracking = () => {
  const { organization } = useOrganization();
  const organizationId = organization.canonical_name;

  const { id: currentUserId } = useCurrentUser();
  const { id: workspaceId, isTeamSync, isGroup } = useWorkspace();
  const appId = useApp();

  const track = ({ eventName, properties = {}, options = {} }) => {
    const propertiesToSend = {
      product_feature: 'Workspace',
      sub_product_feature: 'Meeting Snapshot',
      user: currentUserId,
      app_id: appId,
      workspace_id: workspaceId,
      is_team_sync: isTeamSync,
      is_group: isGroup,
      organization_id: organizationId,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend, options);
  };

  const trackViewedSnapshot = ({ snapshot_id }: { snapshot_id: string }) => {
    track({ eventName: 'Viewed Snapshot', properties: { snapshot_id } });
  };

  const trackViewedEmptyState = () => {
    track({ eventName: 'Viewed Meeting History Empty State' });
  };

  const trackOpenedSnapshotPicker = () => {
    track({ eventName: 'Opened Snapshot Picker' });
  };

  const trackDismissedWelcomeAnnoucement = () => {
    track({ eventName: 'Dismissed Welcome Announcement', options: { integrations: { Calixa: false } } });
  };

  const trackClickedLearnMore = ({ from }: { from: 'welcome_announcement' }) => {
    track({ eventName: 'Clicked Leaarn More', properties: { from } });
  };

  return {
    trackViewedSnapshot,
    trackViewedEmptyState,
    trackOpenedSnapshotPicker,
    trackDismissedWelcomeAnnoucement,
    trackClickedLearnMore,
  };
};
